<template>
    <div class="setting-page-content-wrapper chat-theme-settings">
        <div class="page-header">
            <div class="title">{{ $t("message.chatThemeSettings") }}</div>
            <div class="subtitle">{{ $t("settings.chatThemeSettingsSubtitles") }}</div>
        </div>
        <section>
            <FeatureItem
                v-model="isVersionV2"
                :title="$t('settings.visitorNew')"
                icon=""
                description="You can use the new version of the visitor theme."
            />
            <ChatThemeEditor :update-settings="updateSettings" />
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../utils/log2";
import WirelessKeyboardIcon from "../../../../components/svg/icons/WirelessKeyboardIcon.vue";
import FeatureItem from "../components/FeatureItem.vue";
import * as _ from "lodash";
import ChatThemeEditor from "../components/theme/ChatThemeEditor.vue";

const log = log2("Settings/ChatThemeSettings");

export default {
    name: "ChatThemeSettings",
    components: {
        WirelessKeyboardIcon,
        FeatureItem,
        ChatThemeEditor,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            previewLoading: false,
            isPreviewActive: !!window.supsis,
            alphaMap: {
                100: "ff",
                95: "f2",
                90: "e6",
                85: "d9",
                80: "cc",
                75: "bf",
                70: "b3",
                65: "a6",
                60: "99",
                55: "8c",
                50: "80",
                45: "73",
                40: "66",
                35: "59",
                30: "4d",
                25: "40",
                20: "33",
                15: "26",
                10: "1a",
                5: "0d",
                0: "00",
            },
            alphaMapRev: {
                ff: "100",
                f2: "95",
                e6: "90",
                d9: "85",
                cc: "80",
                bf: "75",
                b3: "70",
                a6: "65",
                99: "60",
                "8c": "55",
                80: "50",
                73: "45",
                66: "40",
                59: "35",
                "4d": "30",
                40: "25",
                33: "20",
                26: "15",
                "1a": "10",
                "0d": "5",
                "00": "0",
            },
        };
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            allThemeColors: (state) => state.setting.allThemeColors,
        }),
        isVersionV2: {
            get() {
                return this.settings.chatCustomizationSettings.isVersionV2;
            },
            set(value) {
                this.updateSettings("chatCustomizationSettings.isVersionV2", value);
            },
        },
    },
    methods: {
        readValue(id) {
            if (id === "writing") {
                return this.settings.writing == 1;
            } else {
                return this.settings[id];
            }
        },
        setValue(key, value) {
            this.updateSettings(key, value);
        },
        addAlpha(hex, e) {
            hex = hex.substring(1).split("");
            if (hex.length === 8) {
                hex.pop();
                hex.pop();
            }
            hex = "#" + hex.join("");
            return hex + this.alphaMap[e];
        },
        integrationScript() {
            const isProduction = process.env.PRODUCTION === "true";
            const hostname = this.site.customerClientAddress;
            const protocol = isProduction ? "https" : "http";
            const path = isProduction ? "static/js/loader.js" : "loader.js";
            return `${protocol}://${hostname}/${path}`;
        },
    },
    mounted() {},
    beforeDestroy() {
        const supsis = window.supsis;
        if (!!supsis) supsis("destroy");
        this.isPreviewActive = false;
    },
    watch: {},
};
</script>

<style scoped lang="scss">
.chat-theme-settings {
    .width-80 {
        width: 80%;
    }

    .right {
        display: flex !important;
        align-items: center !important;

        .ant-switch-checked {
            background-color: var(--color-bg-primary-default);
        }
    }

    .font-size-13 {
        font-size: 13px;
    }

    .card {
        margin-top: 50px;
        width: 900px;
    }

    .btnColor {
        margin: 14px;
        border-color: var(--color-bg-primary-default) !important;
        color: var(--color-bg-primary-default) !important;
    }
}
</style>
